module.exports = __webpack_public_path__ + "img/img-ae5ee1a6.3ac2c5f7.png";